<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>

    <div class="card">
      <div class="card-header">
        <h3 v-if="mData.viewMode === 'create'">THÊM MỚI SẢN PHẨM</h3>
        <h3 v-if="mData.viewMode === 'detail'">CHI TIẾT SẢN PHẨM</h3>
        <h3 v-if="mData.viewMode === 'update'">CẬP NHẬT SẢN PHẨM</h3>
      </div>

      <div class="card-body">
        <el-form :model="mData.dataForm" :rules="mData.validForm" ref="myForm">
          <b-row>
            <b-col md="4">
              <el-form-item label="Mã sản phẩm" prop="ma_sp">
                <el-input
                  v-model="mData.dataForm.ma_sp"
                  :disabled="
                    mData.viewMode == 'detail' || mData.viewMode == 'update'
                  "
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Tên sản phẩm" prop="ten">
                <el-input
                  v-model="mData.dataForm.ten"
                  :disabled="mData.viewMode == 'detail'"
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Giá niêm yết" prop="gia_niem_yet">
                <div>
                  <el-input
                    type="number"
                    v-model="mData.dataForm.gia_niem_yet"
                    :disabled="mData.viewMode == 'detail'"
                    min="0"
                    style="width: calc(100% - 35px)"
                  ></el-input>
                  <span>&nbsp;VNĐ</span>
                </div>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <el-form-item label="Loại" prop="loai">
                <el-select
                  v-model="mData.dataForm.loai"
                  placeholder="Chọn loại sản phẩm"
                  :disabled="mData.viewMode == 'detail'"
                >
                  <el-option
                    v-for="item in mData.listLoai"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="4" v-if="mData.dataForm.loai !== 'khac'">
              <el-form-item label="Gói dịch vụ" prop="goi_dich_vu_id">
                <el-select
                  v-model="mData.dataForm.goi_dich_vu_id"
                  placeholder="Chọn gói dịch vụ"
                  :disabled="mData.viewMode == 'detail'"
                >
                  <el-option
                    v-for="item in mData.listGoi"
                    :key="item.id"
                    :label="item.ten"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Đơn vị" prop="don_vi">
                <el-input
                  v-model="mData.dataForm.don_vi"
                  :disabled="mData.viewMode == 'detail'"
                ></el-input>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row class="form-space-between">
            <b-col v-if="mData.viewMode != 'create'">
              <el-form-item class="margin-checkbox" prop="hieu_luc">
                <el-checkbox
                  v-model="mData.dataForm.hieu_luc"
                  :disabled="mData.viewMode == 'detail'"
                  >Hiệu lực</el-checkbox
                >
              </el-form-item>
            </b-col>
            <b-col>
              <el-form-item class="margin-checkbox" prop="dai_ly_ban">
                <el-checkbox
                  v-model="mData.dataForm.dai_ly_ban"
                  :disabled="mData.viewMode == 'detail'"
                  >Đại lý bán</el-checkbox
                >
              </el-form-item>
            </b-col>
            <b-col>
              <el-form-item class="margin-checkbox" prop="phu_kien">
                <el-checkbox
                  v-model="mData.dataForm.phu_kien"
                  :disabled="mData.viewMode == 'detail'"
                  >Phụ kiện</el-checkbox
                >
              </el-form-item>
            </b-col>
          </b-row>
          <b-row v-if="mData.dataForm.phu_kien">
            <b-col md="6" v-if="mData.viewMode != 'detail'">
              <el-form-item label="Sản phẩm cha">
                <el-select
                  v-model="mData.sanPhamChaId"
                  filterable
                  placeholder="Chọn"
                  @change="changeListCha()"
                >
                  <el-option
                    v-for="item in mData.listSanPham"
                    :key="item.id"
                    :label="item.ten"
                    :value="item.id"
                  />
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item
                label="Danh sách sản phẩm cha"
                v-if="mData.listSanPhamCha && mData.listSanPhamCha.length > 0"
                class="list-node-hide"
              >
                <div
                  class="wrapper-node"
                  v-for="(item, index) in mData.listSanPhamCha"
                  :key="item.id"
                >
                  <span className="txt_ho_ten">
                    {{ item.ten }}
                  </span>
                  <i
                    class="fa-solid fa-xmark"
                    v-if="mData.viewMode != 'detail'"
                    @click="deleteSanPhamCha(item, index)"
                  ></i>
                </div>
              </el-form-item>
            </b-col>
          </b-row>
          <el-form-item label="Mô tả ngắn">
            <el-input
              v-model="mData.dataForm.mo_ta_ngan"
              :rows="4"
              type="textarea"
              placeholder="Nhập mô tả"
              :disabled="mData.viewMode == 'detail'"
            />
          </el-form-item>
          <el-form-item label="Mô tả dài">
            <el-input
              v-model="mData.dataForm.mo_ta"
              :rows="6"
              type="textarea"
              placeholder="Nhập mô tả"
              :disabled="mData.viewMode == 'detail'"
            />
          </el-form-item>

          <div class="text-center mt-3">
            <el-button
              type="danger"
              plain
              @click="fn_cancel()"
              v-ladda
              v-if="mData.viewMode === 'update' || mData.viewMode === 'create'"
              >hủy</el-button
            >
            <el-button
              type="primary"
              @click="fn_addSanPham()"
              v-ladda
              v-if="mData.viewMode === 'create'"
              >thêm mới</el-button
            >
            <el-button
              type="primary"
              @click="fn_update()"
              v-ladda
              v-if="mData.viewMode === 'update'"
              >cập nhật</el-button
            >
            <el-button
              type="primary"
              @click="fn_back()"
              v-ladda
              v-if="mData.viewMode === 'detail'"
              >quay lại</el-button
            >
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { Circle4 } from "vue-loading-spinner";
import MethodService from "@/service/MethodService";
import DataForm from "@/dataForm/dataFormSanPham";
import mushroom from "viettoc-api";
import ValidService from "@/service/ValidService";

export default {
  data() {
    return {
      loading: false,
      mData: {
        viewMode: "create",
        dataForm: MethodService.copyObject(DataForm.dataForm),
        validForm: {
          ten: [ValidService.required],
          ma_sp: [ValidService.required],
          gia_niem_yet: [ValidService.required, ValidService.checkNumber],
          loai: [ValidService.required],
          goi_dich_vu_id: [ValidService.required],
        },
        listSanPham: [],
        sanPhamChaId: "",
        listSanPhamCha: [],
        listLoai: [
          {
            value: "khoi_tao",
            label: "Khởi tạo",
          },
          {
            value: "gia_han",
            label: "Gia hạn",
          },
          {
            value: "nang_cap",
            label: "Nâng cấp",
          },
          {
            value: "khac",
            label: "Khác",
          },
        ],
        listGoi: [],
      },
    };
  },
  components: {
    Circle4,
  },
  methods: {
    async getSanPhamId() {
      try {
        const response = await mushroom.prd_san_pham.findByIdAsync({
          id: this.$router.currentRoute.params.id,
        });
        console.log("Thông tin prd_san_pham trả về: %o", response);
        this.mData.dataForm = response.result;
        console.log("sản phẩm: ", this.mData.dataForm);
        if (
          response.result.san_pham_cha_ids &&
          response.result.san_pham_cha_ids.length > 0
        ) {
          this.mData.listSanPhamCha = this.mData.listSanPham.filter((item) =>
            response.result.san_pham_cha_ids.includes(item.id)
          );
          this.mData.listSanPham = this.mData.listSanPham.filter(
            (item) => !response.result.san_pham_cha_ids.includes(item.id)
          );
        }
        console.log("list sản phẩm cha: ", this.mData.listSanPhamCha);
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    // danh sách sản phẩm
    async getListSanPham() {
      try {
        const response = await mushroom.prd_san_pham.getAllAsync({
          fields:
            "id,ten,ma_sp,mo_ta_ngan,mo_ta,gia_niem_yet,dai_ly_ban,phu_kien,san_pham_cha_ids,hieu_luc,thoi_diem_tao,nguoi_tao_id,thoi_diem_cap_nhat,nguoi_cap_nhat_id",
          filters: ["phu_kien=false"],
          limit: 100,
        });
        console.log("Các list prd_san_pham thỏa mãn: %o", response);
        this.mData.listSanPham = response.result;
        console.log("danh sách sản phẩm cha: ", this.mData.listSanPham);
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    async getListGoi() {
      try {
        const response = await mushroom.prd_goi_dich_vu.listAsync();
        console.log("Các prd_goi_dich_vu thỏa mãn: %o", response);
        this.mData.listGoi = response.result;
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    // reset form
    fn_resetForm() {
      this.$refs.myForm.$el.reset();
    },
    fn_resetDataForm() {
      this.mData.dataForm.ten = undefined;
      this.mData.dataForm.ma_sp = undefined;
      this.mData.dataForm.mo_ta_ngan = undefined;
      this.mData.dataForm.mo_ta = undefined;
      this.mData.dataForm.gia_niem_yet = undefined;
      this.mData.dataForm.dai_ly_ban = false;
      this.mData.dataForm.phu_kien = false;
      this.mData.dataForm.san_pham_cha_ids = [];
      this.mData.dataForm.hieu_luc = false;
    },
    fn_cancel() {
      this.fn_resetForm();
      this.fn_resetDataForm();
      this.$router.go(-1);
    },
    // thêm mới
    async fn_addSanPham() {
      const fn_addSanPham = {
        ten: this.mData.dataForm.ten,
        ma_sp: this.mData.dataForm.ma_sp,
        mo_ta_ngan: this.mData.dataForm.mo_ta_ngan,
        mo_ta: this.mData.dataForm.mo_ta,
        gia_niem_yet: Number(this.mData.dataForm.gia_niem_yet),
        dai_ly_ban: this.mData.dataForm.dai_ly_ban
          ? this.mData.dataForm.dai_ly_ban
          : false,
        phu_kien: this.mData.dataForm.phu_kien
          ? this.mData.dataForm.phu_kien
          : false,
        san_pham_cha_ids: this.mData.listSanPhamCha.map((item) => item.id),
        loai: this.mData.dataForm.loai,
        goi_dich_vu_id:
          this.mData.dataForm.loai !== "khac"
            ? this.mData.dataForm.goi_dich_vu_id
            : undefined,
        don_vi: this.mData.dataForm.don_vi,
      };
      console.log("dữ liệu tạo sản phẩm: ", fn_addSanPham);
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          if (this.mData.dataForm.ten == undefined) {
            window.toastr.warning("Cần nhập tên sản phẩm");
            MethodService.stopLadda();
          } else if (this.mData.dataForm.ma_sp == undefined) {
            window.toastr.warning("Cần nhập mã sản phẩm");
            MethodService.stopLadda();
          } else if (this.mData.dataForm.gia_niem_yet == undefined) {
            window.toastr.warning("Cần nhập giá niêm yết của sản phẩm");
            MethodService.stopLadda();
          } else if (this.mData.dataForm.loai == undefined) {
            window.toastr.warning("Cần chọn loại sản phẩm");
            MethodService.stopLadda();
          } else if (
            this.mData.dataForm.goi_dich_vu_id == undefined &&
            this.mData.dataForm.loai &&
            this.mData.dataForm.loai !== "khac"
          ) {
            window.toastr.warning("Cần chọn gói dịch vụ");
            MethodService.stopLadda();
          } else {
            try {
              const newId = await mushroom.prd_san_pham.createAsync(
                fn_addSanPham
              );
              console.log("Thêm mới thành công, new id: %o", newId);
              window.toastr.success("Thêm mới sản phẩm thành công");
              this.$router.push({
                name: "DanhSachSanPham",
              });
            } catch (error) {
              console.error("Có lỗi: %o", error);
              console.log(this.$refs.myForm.$el);
              if (error.code === 4) {
                window.toastr.error(this.aLang.no_server);
              } else if (error.code === 2) {
                window.toastr.error("Gặp sự cố tải dữ liệu");
              } else {
                window.toastr.error("Mã sản phẩm đã tồn tại");
                MethodService.stopLadda();
              }
            }
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    // cập nhật
    async fn_update() {
      const fn_addSanPham = {
        id: this.$router.currentRoute.params.id,
        ten: this.mData.dataForm.ten,
        ma_sp: this.mData.dataForm.ma_sp,
        mo_ta_ngan: this.mData.dataForm.mo_ta_ngan,
        mo_ta: this.mData.dataForm.mo_ta,
        gia_niem_yet: Number(this.mData.dataForm.gia_niem_yet),
        dai_ly_ban: this.mData.dataForm.dai_ly_ban
          ? this.mData.dataForm.dai_ly_ban
          : false,
        phu_kien: this.mData.dataForm.phu_kien
          ? this.mData.dataForm.phu_kien
          : false,
        hieu_luc: this.mData.dataForm.hieu_luc,
        san_pham_cha_ids: this.mData.listSanPhamCha.map((item) => item.id),
        loai: this.mData.dataForm.loai,
        goi_dich_vu_id:
          this.mData.dataForm.loai !== "khac"
            ? this.mData.dataForm.goi_dich_vu_id
            : undefined,
        don_vi: this.mData.dataForm.don_vi,
      };
      console.log("dữ liệu update sản phẩm: ", fn_addSanPham);
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          if (this.mData.dataForm.ten == undefined) {
            window.toastr.warning("Cần nhập tên sản phẩm");
            MethodService.stopLadda();
          } else if (this.mData.dataForm.ma_sp == undefined) {
            window.toastr.warning("Cần nhập mã sản phẩm");
            MethodService.stopLadda();
          } else if (this.mData.dataForm.gia_niem_yet == undefined) {
            window.toastr.warning("Cần nhập giá niêm yết của sản phẩm");
            MethodService.stopLadda();
          } else if (this.mData.dataForm.loai == undefined) {
            window.toastr.warning("Cần chọn loại sản phẩm");
            MethodService.stopLadda();
          } else if (
            this.mData.dataForm.goi_dich_vu_id == undefined &&
            this.mData.dataForm.loai &&
            this.mData.dataForm.loai !== "khac"
          ) {
            window.toastr.warning("Cần chọn gói dịch vụ");
            MethodService.stopLadda();
          } else {
            try {
              const response = await mushroom.prd_san_pham.partialUpdateAsync(
                fn_addSanPham
              );
              if (response.result == this.$router.currentRoute.params.id) {
                window.toastr.success("Cập nhật sản phẩm thành công");
                this.$router.go(-1);
              } else {
                window.toastr.warning("Dữ liệu không thay đổi");
                MethodService.stopLadda();
              }
            } catch (error) {
              MethodService.stopLadda();
              console.error("Có lỗi: %o", error);
              if (error.code === 4) {
                window.toastr.error(this.aLang.no_server);
              } else if (error.code === 2) {
                window.toastr.error("Máy chủ không phản hồi");
              } else window.toastr.error("Đã có lỗi xảy ra");
            }
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    // quay lại
    fn_back() {
      this.$router.go(-1);
    },
    // thêm sản phẩm cha
    changeListCha() {
      if (this.mData.sanPhamChaId.length > 0) {
        this.mData.listSanPhamCha.push(
          this.mData.listSanPham.find(
            (item) => item.id === this.mData.sanPhamChaId
          )
        );

        this.mData.listSanPham.forEach((item, index) => {
          if (item.id === this.mData.sanPhamChaId) {
            this.mData.listSanPham.splice(index, 1);
          }
        });
        this.mData.sanPhamChaId = "";
      }
    },
    // xóa sản phẩm cha
    deleteSanPhamCha(item, index) {
      this.mData.listSanPhamCha.splice(index, 1);
      this.mData.listSanPham.push(item);
    },
  },

  async created() {
    await this.getListGoi();
    await this.getListSanPham();
    // kiểm tra loại viewMode
    console.log(this.$router.currentRoute.name);
    if (this.$router.currentRoute.name == "ThemMoiSanPham") {
      this.mData.viewMode = "create";
      this.loading = false;
    }
    if (this.$router.currentRoute.name == "ChiTietSanPham") {
      this.mData.viewMode = "detail";
      await this.getSanPhamId();
    }
    if (this.$router.currentRoute.name == "CapNhatSanPham") {
      this.mData.viewMode = "update";
      await this.getSanPhamId();
    }
  },
};
</script>
<style scoped>
.form-space-between {
  display: flex;
}
.center-checkbox {
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.margin-checkbox {
  margin-bottom: 8px;
}
.list-node-hide {
  display: flex;
  flex-direction: column;
}
.wrapper-node {
  align-items: center;
  border: 1px solid #cec6c5;
  border-radius: 6px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  padding: 0px 10px;
  position: relative;
}
.icon-detail {
  position: absolute;
  right: 10px;
  bottom: 9px;
  color: #717378;
  cursor: pointer;
}
</style>
